// extracted by mini-css-extract-plugin
module.exports = {"SubtleButton":"SubtleButton_SubtleButton__3ZZ6D","shrink":"SubtleButton_shrink__3Z9ZL","pill":"SubtleButton_pill__3omN2"};